import * as moment from "moment";
const getRegisterdDevicMapper = (AllRegisteredDevices) => {
    const result = {
        type: "",
        dvLst: [],
    };
    if (AllRegisteredDevices) {
        const list = AllRegisteredDevices.data.dvLst.map((item) => {
            return {
                appId: item.appId,
                browserName: item.bwsNm,
                clvrTpId: item.clvrTpId,
                deviceName: item.devNm,
                lastLogin: moment(item.llt).format("DD-MM-YYYY"),
                platform: item.pltf,
                regt: moment(item.regt).format("DD-MM-YYYY"),
            };
        });
        result.dvLst = list;
    }
    return result;
};
export default getRegisterdDevicMapper;
